import { gql } from "@apollo/client";

export const UPDATE_INVOICE_DATA = gql`
  mutation updateInvoiceData(
    $name: String
    $surname: String
    $cod_fiscale: String
    $address: String
    $cap: String
    $city: String
    $province: String
    $phone: String
  ) {
    updatePatientProfileInfos(
      invoice_name: $name
      invoice_surname: $surname
      invoice_cod_fiscale: $cod_fiscale
      invoice_address: $address
      invoice_cap: $cap
      invoice_city: $city
      invoice_province: $province
      invoice_phone: $phone
    ) {
      id
    }
  }
`;
